<template>
  <div class="center">
    <Timer
      v-if="status === 'isPending'"
      :timeInSeconds="120"
      :isTimedOut="isTimedOut"
    />
    <a-icon
      v-if="status === 'isTimeOut'"
      type="warning"
      :style="{ fontSize: '60px', marginBottom: '1rem', color: '#ffcc00' }"
    />
    <a-icon
      v-if="status === 'isSuccess'"
      type="check-circle"
      :style="{ fontSize: '60px', marginBottom: '1rem', color: '#87d068' }"
    />
    <p>{{ msg }}</p>
    <a-button
      type="default"
      shape="circle"
      @click="confirmIntervention"
      class="btn-tech"
      icon="tool"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { Progress } from "ant-design-vue";
import Timer from "./Timer.vue";
import { firebaseRoomStages, mutationTypes } from "../store/modules/base";

Vue.use(Progress);

export default {
  name: "TicketPending",
  components: { Timer },
  data() {
    return {
      msg:
        "Votre demande a bien été envoyée à l’equipe IT. Nous mettons tout en oeuvre pour vous repondre au plus vite.",
      status: "isPending",
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === mutationTypes.UPDATE_ROOM_STATUS) {
        if (mutation.payload === firebaseRoomStages.EXPIRED) {
          this.isTimedOut();
          return;
        }
        if (mutation.payload === firebaseRoomStages.RESPONDED) {
          this.isAquitted();
          return;
        }
      }
    });
  },
  beforeDestroy: function() {
    this.unsubscribe();
    this.$store.dispatch("unsubscribeToRoom", this.$route.query.roomId);
  },
  methods: {
    confirmIntervention() {
      const roomId = this.$route.query.roomId;
      this.$store.dispatch("confirmIntervention", roomId).then(() => {
        setTimeout(() => {
          this.$store.dispatch("resetStage");
        }, 3000);
      });
    },
    isTimedOut() {
      this.status = "isTimeOut";
      this.msg =
        "Aucun technicien n'a répondu pour l'instant. Nous mettons tout en oeuvre pour vous répondre au plus vite.";
    },
    isAquitted() {
      this.status = "isSuccess";
      this.msg =
        "Un technicien a pris en charge votre demande. Il est en route !";
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  text-align: center;
}

.ant-progress {
  margin-bottom: 1rem;
}

.btn-tech {
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
}
</style>
